module.exports = __webpack_public_path__ + "static/media/obs2.2fbfcddf.png";